import { BN } from "bn.js";
import { createContext, useContext, useState, useEffect } from "react";
import { useWeb3 } from "./web3-context";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useUser } from "./user-context";
const defaultValue = {
    userBalance: {revv: {balance: "0", decimals: 18}},
    isLoadingBal: true,
    getBalances: async () => {},
};
export const WalletContext = createContext(defaultValue);
const WalletContextProvider = ({ children }) => {
    const { primaryWallet } = useDynamicContext();
    const { isLoggedIn } = useUser();
    const { getPublicClient, getContractCallObj, networkName } = useWeb3();
    const [ userBalance, setUserBalance ] = useState({revv: {balance: "0", decimals:
                18}});
    const [ isLoadingBal, setIsLoadingBal ] = useState(true);
    useEffect(() => {
        const init = async () => {
            await getBalances();
        }
        if (isLoggedIn && networkName && primaryWallet?.address) {
            init();
        } else {
            setUserBalance({revv: {balance: "0", decimals: 18}});
        }
    }, [networkName, primaryWallet?.address, isLoggedIn])
    const getBalances = async (tokenName = "REVV") => {
        try {
            setIsLoadingBal(true);
            const publicClient = await getPublicClient();
            const balanceOfObj = await getContractCallObj(tokenName, "balanceOf",
                {args: [primaryWallet.address]});
            const decimalsObj = await getContractCallObj(tokenName, "decimals");
            const bal = await publicClient.readContract(balanceOfObj);
            const decimals = await publicClient.readContract(decimalsObj);
            setUserBalance(prev => ({
                ...prev,
                [tokenName.toLowerCase()]: {
                    balance: new BN(bal).toString(),
                    decimals: Number(decimals)
                }
            }))
        } catch(e) {
            console.error(e);
        } finally {
            setIsLoadingBal(false);
        }
    }
    return (
        <WalletContext.Provider value={{
            userBalance,
            isLoadingBal,
            getBalances,
        }}>
            {children}
        </WalletContext.Provider>
    );
};
const useWallet = () => {
    const context = useContext(WalletContext);
    if (!context) {
        throw new Error("useWallet must be used within a WalletContextProvider");
    }
    return context;
};
export { useWallet, WalletContextProvider };